import React from 'react';
import { ArrowLeft, ChevronRight, MapPin } from 'lucide-react';
import { EmptyState } from './EmptyState';
interface Area {
  id: string;
  name: string;
  count: number;
}
interface AreaListProps {
  provinceName: string;
  provinceId: string;
  onBack: () => void;
  onAreaClick?: (areaId: string) => void;
}
// Mock data for areas
const areasByProvince: Record<string, Area[]> = {
  wc: [{
    id: 'ct-cbd',
    name: 'Cape Town CBD',
    count: 2
  }, {
    id: 'north',
    name: 'Northern Suburbs',
    count: 1
  }, {
    id: 'south',
    name: 'Southern Suburbs',
    count: 1
  }],
  kzn: [{
    id: 'dbn-central',
    name: 'Durban Central',
    count: 3
  }, {
    id: 'umhlanga',
    name: 'Umhlanga',
    count: 2
  }],
  gp: [{
    id: 'sandton',
    name: 'Sandton',
    count: 2
  }, {
    id: 'midrand',
    name: 'Midrand',
    count: 1
  }]
};
export function AreaList({
  provinceName,
  provinceId,
  onBack,
  onAreaClick
}: AreaListProps) {
  const areas = areasByProvince[provinceId] || [];
  return <div className="flex flex-col space-y-6 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-444">
      {/* Header Section */}
      <div className="flex flex-col space-y-2" data-id="element-445">
        <button onClick={onBack} className="group flex w-fit items-center text-sm font-medium text-[#5a7280] hover:text-[#062133] transition-colors min-h-[44px] px-2 -ml-2 rounded-lg hover:bg-[#062133]/5" aria-label="Back to province list" data-id="element-446">
          <ArrowLeft className="mr-1 h-4 w-4 transition-transform group-hover:-translate-x-1" data-id="element-447" />
          Back to Provinces
        </button>

        <div className="flex items-center justify-between" data-id="element-448">
          <div data-id="element-449">
            <h2 className="text-2xl font-bold text-[#062133]" data-id="element-450">
              {provinceName} Areas
            </h2>
            <p className="text-[#5a7280]" data-id="element-451">
              Select an area to view specific sites
            </p>
          </div>
        </div>
      </div>

      {/* Area List Card */}
      <div className="overflow-hidden rounded-xl border border-[#e5e5e5] bg-white shadow-sm" data-id="element-452">
        <div className="divide-y divide-[#e5e5e5]" data-id="element-453">
          {areas.length > 0 ? areas.map(area => <button key={area.id} onClick={() => onAreaClick?.(area.id)} className="group flex w-full items-center justify-between p-5 text-left transition-all hover:bg-[#fafaf9] focus:outline-none focus:bg-[#fafaf9] min-h-[72px]" data-id="element-454">
                <div className="flex items-center gap-4" data-id="element-455">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#062133]/5 text-[#062133]" data-id="element-456">
                    <MapPin className="h-5 w-5" data-id="element-457" />
                  </div>
                  <div data-id="element-458">
                    <span className="block text-lg font-semibold text-[#062133]" data-id="element-459">
                      {area.name}
                    </span>
                    <span className="text-sm text-[#5a7280]" data-id="element-460">View sites</span>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-461">
                  <span className="inline-flex items-center rounded-full bg-amber-500/10 px-3 py-1 text-sm font-medium text-amber-600" data-id="element-462">
                    {area.count} {area.count === 1 ? 'site' : 'sites'}
                  </span>
                  <ChevronRight className="h-5 w-5 text-[#e5e5e5] transition-colors group-hover:text-[#062133]" data-id="element-463" />
                </div>
              </button>) : <div className="p-0 border-none" data-id="element-464">
              <EmptyState icon={MapPin} title="No sites flagged in this area" description="All sites in this province are operating normally" data-id="element-465" />
            </div>}
        </div>
      </div>
    </div>;
}